import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { IConfigs, ISession } from "../models";

export interface IAuthState {
  config?: IConfigs;
  session?: ISession;
}

const initialState: IAuthState = {};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setConfig: (state, action: PayloadAction<IConfigs | undefined>) => {
      state.config = action.payload;
    },
    setSession: (state, action: PayloadAction<ISession | undefined>) => {
      state.session = action.payload;
    },
  },
});

export const authActions = { ...authSlice.actions };
const authReducer = authSlice.reducer;
export default authReducer;
